<script setup>
import { $t } from "~/utils/index.js";
import ImageZoom from 'js-image-zoom'
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'


const props = defineProps({
  options: {
    type: Object,
    default: () => ({})
  }
})

const vueImageZoom = ref(null)
let imageZoom = null
let observer = null

function addNoReferrerToImages(container) {
  const images = container.querySelectorAll('img')
  images.forEach(img => {
    if (!img.referrerPolicy) {
      img.referrerPolicy = 'no-referrer'
    }
  })
}

function rerenderImageZoom() {
  if (vueImageZoom.value) {
    const img = new Image()
    img.src = props.options.img
    img.referrerpolicy = "no-referrer"
    img.onload = () => {
      imageZoom = new ImageZoom(vueImageZoom.value, { ...props.options });
      
      // 确保初始图片有 no-referrer 属性
      addNoReferrerToImages(vueImageZoom.value)
      
      // 监听 DOM 变化，确保动态创建的图片也有 no-referrer 属性
      if (observer) {
        observer.disconnect()
      }
      
      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.tagName === 'IMG') {
                  node.referrerPolicy = 'no-referrer'
                } else {
                  addNoReferrerToImages(node)
                }
              }
            })
          }
        })
      })
      
      observer.observe(vueImageZoom.value, {
        childList: true,
        subtree: true
      })
    }
  }
}

function kill() {
  imageZoom?.kill()
  if (observer) {
    observer.disconnect()
    observer = null
  }
}

onMounted(() => {
  rerenderImageZoom()
})

onBeforeUnmount(() => {
  kill()
})

watch(() => props.options, () => {
  kill()
  rerenderImageZoom()
})

</script>

<template>
  <div ref="vueImageZoom" class="vue-image-zoom" w-full h-full relative />
</template>

<style>
.vue-image-zoom:first-child img {
  border-radius: 12px;
  margin: 0 auto;
}
</style>
